module.exports = __webpack_public_path__ + "img/landing-feature3.33ed7638.png";